import { defineComponent as _defineComponent } from 'vue'
import LanguageSelector from '@/components/LanguageSelector.vue';
import urls from '@/router/urls';
import { useConfigStore } from '@gms/stores/src/stores/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'Image',
  setup(__props) {

const configStore = useConfigStore();

return { __sfc: true,configStore, LanguageSelector, urls }
}

})